module.exports = __webpack_public_path__ + "static/media/27.cd848fd8.png";